import * as actions from '../sections-action/sections.action';
import { SectionState, SectionRecordState } from './section.state';

export const initialState: SectionState = new SectionRecordState() as unknown as SectionState;

export function reducer(
    state = initialState,
    { type, payload }: any
): SectionState {
    if (!type) {
        return state;
    }
    switch (type) {


        // <------------------SECTION LIST ---------------> //

        case actions.ActionTypes.DO_SECTION_LIST: {
            return Object.assign({}, state, {
                sectionListLoaded: true,
                sectionListFailed: false,
                sectionListLoading: false
            });
        }

        case actions.ActionTypes.DO_SECTION_LIST_SUCCESS: {
            return Object.assign({}, state, {
                sectionListLoaded: true,
                sectionListFailed: false,
                sectionListLoading: false,
                sectionList: payload.data
            });
        }

        case actions.ActionTypes.DO_SECTION_LIST_FAIL: {
            return Object.assign({}, state, {
                sectionListLoaded: false,
                sectionListFailed: true,
                sectionListLoading: false
            });
        }

        // <------------------SECTION LIST COUNT---------------> //

        case actions.ActionTypes.DO_SECTION_LIST_COUNT: {
            return Object.assign({}, state, {
                sectionListCountLoaded: true,
                sectionListCountFailed: false,
                sectionListCountLoading: false
            });
        }

        case actions.ActionTypes.DO_SECTION_LIST_SUCCESS_COUNT: {
            return Object.assign({}, state, {
                sectionListCount: payload.data,
                sectionListCountLoaded: true,
                sectionListCountFailed: false,
                sectionListCountLoading: false
            });
        }

        case actions.ActionTypes.DO_SECTION_LIST_FAIL_COUNT: {
            return Object.assign({}, state, {
                sectionListCountLoaded: true,
                sectionListCountFailed: false,
                sectionListCountLoading: false
            });
        }

        // <------------------DELETE WIDGET ---------------> //

        case actions.ActionTypes.DO_DELETE_SECTION_ACTION: {
            return Object.assign({}, state, {
                deleteSection: {},
                sectionDeleteLoading: true,
                sectionDeleteLoaded: false,
                sectionDeleteFailed: false
            });
        }

        case actions.ActionTypes.DO_DELETE_SECTION_SUCCESS: {
            return Object.assign({}, state, {
                sectionDeleteLoaded: true,
                sectionDeleteFailed: false,
                sectionDeleteLoading: false,
                deleteSection: payload
            });
        }

        // <------------------ADD WIDGET ---------------> //

        case actions.ActionTypes.DO_ADD_SECTION_ACTION: {
            return Object.assign({}, state, {
                sectionAddLoaded: true,
                sectionAddFailed: false,
                sectionAddLoading: false
            });
        }

        case actions.ActionTypes.DO_ADD_SECTION_SUCCESS: {
            return Object.assign({}, state, {
                sectionAddLoaded: true,
                sectionAddFailed: false,
                sectionAddLoading: false,
                newSection: payload,
            });
        }

        case actions.ActionTypes.DO_ADD_SECTION_FAIL: {
            return Object.assign({}, state, {
                sectionAddLoaded: false,
                sectionAddFailed: true,
                sectionAddLoading: false,
            });
        }

        // <------------------UPDATE WIDGET ---------------> //

        case actions.ActionTypes.DO_UPDATE_SECTION_ACTION: {
            return Object.assign({}, state, {
                sectionUpdateLoading: true,
                sectionUpdateLoaded: false,
                sectionUpdateFailed: false
            });
        }

        case actions.ActionTypes.DO_UPDATE_SECTION_SUCCESS: {
            return Object.assign({}, state, {
                sectionUpdateLoaded: true,
                sectionUpdateFailed: false,
                sectionUpdateLoading: false,
                updateSection: payload
            });
        }

        case actions.ActionTypes.DO_UPDATE_SECTION_FAIL: {
            return Object.assign({}, state, {
                sectionUpdateLoaded: false,
                sectionUpdateFailed: true,
                sectionUpdateLoading: false,
                updateSection: payload
            });
        }
//Get Seection Details

        case actions.ActionTypes.GET_SECTION_DETAILS: {
            return Object.assign({}, state, {
                getSectionDetailsLoaded: false,
                getSectionDetailsFailed: false,
              getBannerDetailsLoading: false,
            });
          }
          case actions.ActionTypes.GET_SECTION_DETAILS_SUCCESS: {
            return Object.assign({}, state, {
                getSectionDetails: payload.data,
                getSectionDetailsLoaded: false,
                getSectionDetailsFailed: false,
              getBannerDetailsLoading: false,
            });
          }
          case actions.ActionTypes.GET_SECTION_DETAILS_FAIL: {
            return Object.assign({}, state, {
                getSectionDetailsLoaded: false,
                getSectionDetailsFailed: false,
              getBannerDetailsLoading: false,
            });
          }

            // <------------------CLEAR SECTION---------------> //

    case actions.ActionTypes.CLEAR: {
        return Object.assign({}, state, {
            sectionList: [],
            sectionListCount: {},
            addSection: {},
            newSection:{},
            updateSection:{},
            getSectionDetails:{}
        })
      }

        default: {
            return state;
        }
    }
}

export const sectionListLoaded = (state: SectionState) =>
    state.sectionListLoaded;
export const sectionListFailed = (state: SectionState) =>
    state.sectionListFailed;
export const sectionListLoading = (state: SectionState) =>
    state.sectionListLoading;
export const sectionList = (state: SectionState) => state.sectionList;

export const sectionListCount = (state: SectionState) => state.sectionListCount;
export const sectionListCountLoaded = (state: SectionState) =>
    state.sectionListCountLoaded;
export const sectionListCountFailed = (state: SectionState) =>
    state.sectionListCountFailed;
export const sectionListCountLoading = (state: SectionState) =>
    state.sectionListCountLoading

export const sectionDeleteLoading = (state: SectionState) =>
    state.sectionDeleteLoading;
export const sectionDeleteLoaded = (state: SectionState) =>
    state.sectionDeleteLoaded;
export const sectionDeleteFailed = (state: SectionState) =>
    state.sectionDeleteFailed;
export const deleteSection = (state: SectionState) => state.deleteSection;

export const getSectionDetails = (state: SectionState) =>
  state.getSectionDetails;
export const getSectionDetailsLoaded = (state: SectionState) =>
  state.getSectionDetailsLoaded;
export const getSectionDetailsLoading = (state: SectionState) =>
  state.getSectionDetailsLoading;
export const getSectionDetailsFailed = (state: SectionState) =>
  state.getSectionDetailsFailed;

  export const getAddSection = (state: SectionState) => state.newSection;
  export const sectionAddLoaded = (state: SectionState) => state.sectionAddLoaded;
export const sectionAddFailed = (state: SectionState) => state.sectionAddFailed;
export const sectionAddLoading = (state: SectionState) =>
  state.sectionAddLoading;

  export const updateSection = (state: SectionState) => state.updateSection;
export const sectionUpdateLoading = (state: SectionState) =>
  state.sectionUpdateLoading;
export const sectionUpdateLoaded = (state: SectionState) =>
  state.sectionUpdateLoaded;
export const sectionUpdateFailed = (state: SectionState) =>
  state.sectionUpdateFailed;
